
import React from 'react';
import Modal from 'react-modal';
import swal from 'sweetalert';

export default class AppointmentCancelModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isCompleted: true,

            cancelledReason: '',
            forceCancel: false,
        };
    }

    componentDidMount() {
    }

    saveOnClick() {
        let infoMessage = '';
        if (!this.state.cancelledReason) {
            infoMessage = 'İptal nedeni boş geçilemez !';
        } /* else if (!this.state.forceCancel) {
            infoMessage = 'İptal nedeni boş geçilemez !';
        } */

        if (infoMessage) {
            swal({
                dangerMode: true,
                icon: 'info',
                title: 'Eksik Bilgi',
                text: infoMessage,
                buttons: 'Tamam'
            });
        } else {
            this.props.saveOnClick(this.state.cancelledReason, this.state.forceCancel);
            this.setState({ cancelledReason: '', forceCancel: false });
        }
    }


    render() {
        return (
            <div className="modal inmodal">
                <div className="modal-dialog">
                    <div className="modal-content animated fadeIn">
                        <Modal
                            isOpen={this.props.isOpen}
                            onRequestClose={this.props.onRequestClose}
                            style={{
                                content: {
                                    position: 'null',
                                    top: 'null',
                                    left: 'null',
                                    right: 'null',
                                    bottom: 'null',
                                    border: 'none',
                                    background: '#fff',
                                    padding: 'null',
                                    maxWidth: '50%',
                                    minWidth: '350px'
                                },
                                overlay: {
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: 'rgba(0,0,0,00.1)',
                                    zIndex: 2500
                                }
                            }}
                        >
                            <div className={this.state.isCompleted ? "ibox-content no-padding" : "ibox-content sk-loading no-padding"}>
                                <div className="sk-spinner sk-spinner-fading-circle">
                                    <div className="sk-circle1 sk-circle"></div>
                                    <div className="sk-circle2 sk-circle"></div>
                                    <div className="sk-circle3 sk-circle"></div>
                                    <div className="sk-circle4 sk-circle"></div>
                                    <div className="sk-circle5 sk-circle"></div>
                                    <div className="sk-circle6 sk-circle"></div>
                                    <div className="sk-circle7 sk-circle"></div>
                                    <div className="sk-circle8 sk-circle"></div>
                                    <div className="sk-circle9 sk-circle"></div>
                                    <div className="sk-circle10 sk-circle"></div>
                                    <div className="sk-circle11 sk-circle"></div>
                                    <div className="sk-circle12 sk-circle"></div>
                                </div>
                                <div className="modal-header d-block text-center text-darkblue">
                                    <button className="close" onClick={this.props.onRequestClose}><span>×</span></button>
                                    <h4 className="modal-title">Randevu İptal</h4>
                                    <h5 className="font-normal">Randevuyu iptal etmek için lütfen aşağıdaki istenilen bilgileri doldurun.</h5>
                                </div>
                                <div className="modal-body text-darkblue">
                                    <label className="d-flex"><input className="mr-2" checked={this.state.forceCancel} onChange={() => this.setState(prevState => ({ forceCancel: !prevState.forceCancel }))} type="checkbox" />Kullanıcının iptal talebini dikkate alma</label>
                                    <strong>İptal Nedeni<strong className="text-danger ml-1">*</strong></strong>
                                    <input className="form-control" onChange={e => this.setState({ cancelledReason: e.target.value })} placeholder="İptal nedeni *" type="text" value={this.state.cancelledReason} />
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-orange" onClick={() => this.saveOnClick()}>Kaydet</button>
                                </div>
                            </div>
                        </Modal>
                    </div>
                </div>
            </div>
        )
    }
}